import './team.scss';
import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';

class Team {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);
		this.gsap();
	}

	gsap() {
		gsap.from('.team .title',
			{
				scrollTrigger: {
					trigger: '.team',
				},
				y: 50,
				duration: .8,
			});

		const avatars = gsap.utils.toArray('.team .avatar');
		avatars.forEach(item => {
			gsap.from(item, {
				scrollTrigger: {
					trigger: item,
					start: 'top bottom',
				},
				y: -30,
				duration: 1,
				opacity: 0,
			});
		});

		const name = gsap.utils.toArray('.team .name');
		name.forEach(item => {
			gsap.from(item, {
				scrollTrigger: {
					trigger: item,
					start: 'top bottom',
				},
				y: -50,
				duration: 1,
			});
		});

		const pos = gsap.utils.toArray('.team .pos');
		pos.forEach(item => {
			gsap.from(item, {
				scrollTrigger: {
					trigger: item,
					start: 'top bottom',
				},
				y: -50,
				duration: 1,
			});
		});
	}

}
new Team();